import jlinq from '@SharedServices/linq.javascript.service.js';
import { v4 as uuidv4 } from 'uuid';

export function findTemplateByTemplateId(templateId, lookupNavigationReferenceData) {

    //first try to find out as a parent
    var tryToFindAsFirstLevel = lookupNavigationReferenceData.FirstOrDefault(x => x.id == templateId);

    if (tryToFindAsFirstLevel != null) {
        return { template: tryToFindAsFirstLevel, parentTemplate: null };
    }

    //it's a child record
    for (var i = 0; i < lookupNavigationReferenceData.length; i++) {

        let recordToTest = lookupNavigationReferenceData[i];

        //try to find the child
        let tryToFindChild = recordToTest.children.FirstOrDefault(x => x.id == templateId);

        if (tryToFindChild != null) {
            return { template: tryToFindChild, parentTemplate: recordToTest };
        }
    }

    //null return.
    throw ('Cant find template by id. Id = ' + templateId);
}

export function createAttachmentGroupGuid() {
    return uuidv4();
}